import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { List } from 'foundations-components/transitional/components/List';
import { View } from 'foundations-components/transitional/components/View';
import { getI18nText } from 'pricing-pages-lib/utils/languageUtils';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import { MONTHLY } from 'self-service-api/constants/Terms';
import ChecklistItem from '../../../components/common/ChecklistItem';
import SkeletonLoadWrapper from '../../../components/common/loading/SkeletonLoadWrapper';
import CrmSuitePriceTermOverride from '../../../components/merch-card/price-display/CrmSuitePriceTermOverride';
import { StarterCrmSuiteBOTranslationKeys } from '../../../constants/BusinessObjectivesTranslationKeys';
import { STARTER_SUITE_CARD } from '../../../constants/tracking/TrackingSources';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { isAppAuthSelector } from '../../../selectors/AuthSelectors';
import { trackClickedLink } from '../../../utils/tracking/trackingEventUtils';
import CardLayout from './CardLayout';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StarterCrmSuiteCard = () => {
  const isAppAuth = useSelector(isAppAuthSelector);
  const history = useHistory();
  const isAppReady = useGlobalLoading();
  const handleLegalLinkClick = () => {
    const url = isAppAuth ? '/suite' : '/suite/starter';
    trackClickedLink({
      name: 'explore-link',
      value: getI18nText('splash-page.explore', {
        locale: 'en-us'
      }),
      type: 'internal',
      url,
      trackingSource: STARTER_SUITE_CARD
    });
    history.push(url);
  };
  return /*#__PURE__*/_jsx(CardLayout, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "splash-page.bundles.STARTER.title"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "splash-page.bundles.STARTER.description"
    }),
    priceComponent: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
      isLoading: !isAppReady,
      heights: [35],
      widths: [90],
      children: /*#__PURE__*/_jsx(CrmSuitePriceTermOverride, {
        productLevel: STARTER,
        termOverride: MONTHLY
      })
    }),
    ctasComponent: /*#__PURE__*/_jsx(Button, {
      use: "secondary",
      onClick: handleLegalLinkClick,
      paddingInline: "800",
      "aria-label": I18n.text('splash-page.exploreProduct', {
        product: I18n.text('splash-page.bundles.STARTER.title')
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "splash-page.explore"
      })
    }),
    content: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(View, {
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "splash-page.bundles.starterCrmSuiteCard.idealFor"
        })
      }), /*#__PURE__*/_jsx(List, {
        children: StarterCrmSuiteBOTranslationKeys.map(bizObjectiveText => /*#__PURE__*/_jsx(ChecklistItem, {
          message: bizObjectiveText
        }, bizObjectiveText))
      })]
    })
  });
};
export default StarterCrmSuiteCard;